import * as React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import MegaMenu from "./megaMenu"
import * as styles from "./menuLink.module.css"
import { Href } from "../utils/helper"

const MenuLink = ({ blok, index }) => {
  // console.log(blok)
  const label = (blok.label && blok.label.value) ? blok.label.value?.join(',') : null
  const tour_type_filter = blok.tour_type_filter ? blok.tour_type_filter : null

  const searchParams = new URLSearchParams();
  if (label) searchParams.append('label', label)
  if (tour_type_filter) searchParams.append('typeOfTour', tour_type_filter)

  const url = blok.link.cached_url.startsWith('http') ?
    blok.link.cached_url :
    ('/' + (searchParams.size ? blok.link.cached_url + '?' + searchParams.toString() : blok.link.cached_url))
  // console.log(url)

  return (
    <span className={`${styles.menuLink} group px-4 cursor-pointer ${blok.hidden ? 'hidden' : ''}`}>
      <a href={Href(blok.link)} {...storyblokEditable(blok)} className="text-base text-nowrap font-medium group-hover:text-gray-900 mt-4 md:mb-6 block group-hover:underline underline-offset-8 decoration-4">
        {blok.name}
      </a>
      { blok.sub_menu && blok.sub_menu.length > 0 &&
      <div className={`hidden group-hover:block absolute left-0 w-full top-20 md:top-auto md:h-auto bg-white z-[99] border-black border-t border-b`}>
        <div className="container max-w-screen-xl flex flex-col md:flex-row md:flex-wrap mx-auto h-[640px] md:h-[290px] cursor-auto overflow-y-auto" 
          style={{scrollbarColor: 'black lightgray'}}>
          {blok.sub_menu.map((sub_blok, i) => <MegaMenu blok={sub_blok} key={i}/>)}
        </div>
      </div>
      }
    </span>
  )
}

export default MenuLink
